const map = {
	"./1.png": "../inc/assets/img/vayu-border-frames/1.png",
	"./10.png": "../inc/assets/img/vayu-border-frames/10.png",
	"./11.png": "../inc/assets/img/vayu-border-frames/11.png",
	"./12.png": "../inc/assets/img/vayu-border-frames/12.png",
	"./2.png": "../inc/assets/img/vayu-border-frames/2.png",
	"./3.png": "../inc/assets/img/vayu-border-frames/3.png",
	"./4.png": "../inc/assets/img/vayu-border-frames/4.png",
	"./5.png": "../inc/assets/img/vayu-border-frames/5.png",
	"./6.png": "../inc/assets/img/vayu-border-frames/6.png",
	"./7.png": "../inc/assets/img/vayu-border-frames/7.png",
	"./8.png": "../inc/assets/img/vayu-border-frames/8.png",
	"./9.png": "../inc/assets/img/vayu-border-frames/9.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../inc/assets/img/vayu-border-frames sync recursive ^\\.\\/.*\\.png$";